/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppReleaseChannelPointerDto } from '../../models/app-release-channel-pointer-dto';

export interface AppReleaseControllerFindCurrentChannelRelease$Params {

/**
 * 앱 식별자
 */
  appId?: 'SIGNAGE_PLAYER';

/**
 * 채널
 */
  channel?: 'LATEST' | 'BETA';

/**
 * 플랫폼
 */
  platform?: 'WINDOWS';

/**
 * 아키텍처
 */
  arch?: 'X64';
}

export function appReleaseControllerFindCurrentChannelRelease(http: HttpClient, rootUrl: string, params?: AppReleaseControllerFindCurrentChannelRelease$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseChannelPointerDto>> {
  const rb = new RequestBuilder(rootUrl, appReleaseControllerFindCurrentChannelRelease.PATH, 'get');
  if (params) {
    rb.query('appId', params.appId, {});
    rb.query('channel', params.channel, {});
    rb.query('platform', params.platform, {});
    rb.query('arch', params.arch, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppReleaseChannelPointerDto>;
    })
  );
}

appReleaseControllerFindCurrentChannelRelease.PATH = '/api/app-releases/channels/current';
